<template>
  <div class="animated fadeIn">
    <component-header
      title="Edit Tax Code"
      :hasSearch="false"
      :hasReload="false"
      :hasCreate="false"
      :hasback="true"
      @back-press="(e) => $emit('edit', e)"
    />
    <b-card>
      <b-row>
        <b-col md="12">
          <div slot="header"></div>
          <b-row class="font-md">
            <b-col md="5">
              <div class="form-group">
                <span>Tax Code</span>
                <input class="form-control" v-model="details.taxCode" />
              </div>
            </b-col>
            <b-col md="5">
              <div class="form-group">
                <span>Country</span>
                <input class="form-control" v-model="details.country" />
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md">
            <b-col md="5">
              <div class="form-group">
                <span>Start Date</span>
                <b-input
                  id="start-date"
                  type="date"
                  v-model="details.startDate"
                ></b-input>
              </div>
            </b-col>
            <b-col md="5">
              <div class="form-group">
                <span>End Date</span>
                <b-input
                  id="end-date"
                  type="date"
                  v-model="details.endDate"
                ></b-input>
              </div>
            </b-col>
          </b-row>
          <div
            v-for="(data, idx) in details.restData.details"
            :key="idx"
            class="mt-3"
          >
            <b-col
              v-for="(taxLine, lIdx) in details.restData.details[idx].taxLines"
              :key="lIdx"
            >
              <b-row>
                <b-col md="10">
                  <b-row>
                    <b-col md="6">
                      <div class="form-group">
                        <label for="start-date">Tax Line Name</label>
                        <b-input
                          id="start-date"
                          type="text"
                          v-model="taxLine.taxLineName"
                        ></b-input>
                      </div>
                    </b-col>
                    <b-col md="6">
                      <div class="form-group">
                        <label for="start-date">Tax Rate</label>
                        <b-input
                          id="start-date"
                          type="text"
                          v-model="taxLine.taxRates[0].tax"
                        ></b-input>
                      </div>
                    </b-col>
                    <b-col md="6" class="mb-3">
                      <div class="form-group">
                        <label for="start-date">Tax Line Type</label>
                        <eb-select
                          type="select"
                          :selected="taxLine.taxRates[0].rateType"
                          :options="['P']"
                          v-model="taxLine.taxRates[0].rateType"
                          label="text"
                          id="start-date"
                        ></eb-select>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col md="2">
                  <div>
                    <b-button
                      class="d-block mb-1"
                      variant="primary"
                      size="sm"
                      @click="removeTaxLime(idx, lIdx)"
                      v-if="details.restData.details[idx].taxLines.length > 1"
                    >
                      Remove
                      <i class="fa fa-minus-circle"></i>
                    </b-button>
                    <b-button
                      class="d-block mt-1"
                      variant="primary"
                      size="sm"
                      @click="addTaxLines(idx)"
                      v-if="
                        details.restData.details[idx].taxLines.length - 1 ===
                        lIdx
                      "
                    >
                      Add Item
                      <i class="fa fa-plus-circle"></i>
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </div>
          <b-row class="p-2">
            <b-col md="12">
              <div class="text-center">
                <eb-button
                  class="btn"
                  classic="mr-1 btn-primary"
                  text="Update"
                  @click.prevent="handleSubmit"
                ></eb-button>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import { shuffleArray } from "@/shared/utils";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
import ebButton from "@/components/FormElements/Button";
import TaxCodeDetails from "@/components/MasterSetup/TaxCode/TaxCodeDetails.vue";
import moment from "moment";
import ebSelect from "@/components/FormElements/Select.vue";
import ComponentHeader from "@/components/componentHeader";

export default {
  name: "editfaq",
  components: {
    ebButton,
    cInput,
    TaxCodeDetails,
    ebSelect,
    ComponentHeader,
  },
  data: () => {
    return {
      show: true,
      taxCode: "",
      country: "",
      startDate: 0,
      endDate: 0,
      taxLines: [
        {
          taxLineName: "",
          taxRates: [
            {
              rangeStart: 0,
              rangeEnd: 0,
              rateType: "",
              tax: 0,
            },
          ],
        },
      ],
    };
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
  methods: {
    onClickTaxline(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable) {
        this.inputObject.details.map((obj) => {
          console.log("input object", obj);
          if (obj.btnText === "Add Line") {
            obj.btnText = "Remove";
            obj.isRemovable = true;
            obj.id = idx + 1;
          }
        });
        this.inputObject.details.push({
          shipFrom: "nil",
          shipTo: "nil",
          billTo: "nil",
          taxLines: [
            {
              taxLineName: "",
              taxRates: [
                {
                  rangeStart: 0,
                  rangeEnd: 0,
                  rateType: "",
                  tax: 0,
                },
              ],
            },
          ],
          btnText: "Add Line",
          isRemovable: false,
          id: this.inputObject.details.length + 1,
        });
        this.inputObject.details.sort((a, b) =>
          a.btnText > b.btnText ? -1 : b.btnText > a.btnText ? 1 : 0
        );
      } else this.inputObject.details.splice(idx, 1);
    },
    addTaxLines(index) {
      this.details.restData.details[index].taxLines.push({
        taxLineName: "",
        taxRates: [
          {
            rangeStart: 0,
            rangeEnd: 0,
            rateType: "",
            tax: 0,
          },
        ],
      });
    },
    removeTaxLime(detailIndex, lineIndex) {
      this.details.restData.details[detailIndex].taxLines.splice(lineIndex, 1);
    },
    handleSubmit() {
      let payload = {
        _id: this.details.restData._id,
        country: this.details.country,
        startDate: moment(this.details.startDate).toDate().getTime(),
        endDate: moment(this.details.endDate).toDate().getTime(),
        taxCode: this.details.taxCode,
        details: this.details.restData.details,
      };

      this.$store.dispatch("taxcode/updateTaxcode", payload).then(() => {
        this.$swal({
          title: "Success",
          text: "Taxcode updated successfully!!",
          type: "success",
        });
      });
      this.$emit("edit");
    },
  },
  async mounted() {
    this.details.startDate = moment(
      this.details.startDate,
      "DD/MM/yyyy"
    ).format("yyyy-MM-DD");
    this.details.endDate = moment(this.details.endDate, "DD/MM/yyyy").format(
      "yyyy-MM-DD"
    );
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
</style>
